// When the strings a screen needs are in (ECONIC bundle budget SH-22). main.tsx boots with the frame's strings only (locales/boot.en.ts)
// and loads the rest of the catalogue right after the first paint; every lazily loaded screen, the agent column and the desk chrome wait
// for it together with their own chunk, so the wait is the slower of the two and no screen ever shows a raw key. WP-SHELL.

let ready: Promise<unknown> = Promise.resolve();

/** main.tsx: the promise of the reader's full catalogue (resolved at once when it is already in). */
export function setLocalesReady(p: Promise<unknown>): void {
  ready = p.catch(() => undefined);
}

/** Resolves when the reader's full catalogue is in (never rejects: a failed load leaves the English fallback and the keys' defaults). */
export function localesReady(): Promise<unknown> {
  return ready;
}

/** A lazy loader that also waits for the catalogue: `lazy(withLocales(() => import("./Screen")))`. */
export function withLocales<T>(load: () => Promise<T>): () => Promise<T> {
  return () => Promise.all([load(), ready]).then(([m]) => m);
}
